const normalizar = (text) =>
  String(text || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

// Claves of every concepto linked to the destajo.
const getClavesDestajo = (destajo) =>
  Array.isArray(destajo?.conceptos)
    ? destajo.conceptos.map(({ clave }) => clave)
    : [];

// Claves of the contract partidas (PartidaContrato) linked to the partida.
const getClavesPartida = (partida) =>
  Array.isArray(partida?.claves) ? partida.claves : [];

// Searches partidas (nombre or PartidaContrato clave), destajos (nombre or
// concepto clave) and subdestajos. Returns null for an empty query; otherwise
// what to show and open: only the matches and their parents. A partida (or
// destajo) that matches itself shows all its children.
export const buscarEnCronograma = (query, partidas, destajos, subdestajos) => {
  const term = normalizar(query).trim();
  if (term === "") return null;
  const matches = (text) => normalizar(text).includes(term);

  const openDestajos = new Set();
  const subdestajosVisibles = new Set();
  (Array.isArray(subdestajos) ? subdestajos : []).forEach((subdestajo) => {
    if (matches(subdestajo.nombre)) {
      openDestajos.add(subdestajo.idDestajo);
      subdestajosVisibles.add(subdestajo.idSubDestajo);
    }
  });

  const openPartidas = new Set();
  const destajosVisibles = new Set();
  const destajosCoinciden = new Set();
  (Array.isArray(destajos) ? destajos : []).forEach((destajo) => {
    const coincide =
      matches(destajo.nombre) || getClavesDestajo(destajo).some(matches);
    if (coincide) destajosCoinciden.add(destajo.idDestajo);
    if (coincide || openDestajos.has(destajo.idDestajo)) {
      openPartidas.add(destajo.idPartida);
      destajosVisibles.add(destajo.idDestajo);
    }
  });

  const partidasCoinciden = new Set(
    (Array.isArray(partidas) ? partidas : [])
      .filter(
        (partida) =>
          matches(partida.nombre) || getClavesPartida(partida).some(matches)
      )
      .map(({ idPartida }) => idPartida)
  );

  const partidasVisibles = new Set([...partidasCoinciden, ...openPartidas]);

  return {
    partidasVisibles,
    partidasCoinciden,
    openPartidas,
    destajosVisibles,
    destajosCoinciden,
    openDestajos,
    subdestajosVisibles,
  };
};
